import configStore from '@/store/modules/configStore';

export default {
    data() {
        return {
            shelfData: null,
            shelfOptions: [{ value: null, label: '-- Bitte wählen --' }],
            manualShelf: false,
        };
    },
    computed: {
        useCustomAgree21ShelfData() {
            return this.config.agree21.uploadShelfdata
                && (
                    this.config.agree21.uploadShelfdata.length > 0
                    || this.config.agree21.uploadShelfdata?.$version === 2
                )
            ;
        },
        uploadShelfDataConfig() {
            if (this.config.agree21.uploadShelfdata?.$version === 2) {
                return this.config.agree21.uploadShelfdata.items;
            }

            return Object.entries(this.config.agree21.uploadShelfdata[0]).map(([id, comment]) => ({ id, comment }));
        },
        ...configStore.mapState({
            config: configStore.STATE.CONFIG,
        }),
    },
    methods: {
        initShelfData(initValue) {
            this.shelfData = initValue;

            let shelfDataFound = false;
            for (const { id, comment } of this.uploadShelfDataConfig) {
                this.shelfOptions.push({
                    value: `${id}-${comment}`,
                    label: `${id} - ${comment}`,
                });
                if (this.shelfData === `${id}-${comment}`) {
                    shelfDataFound = true;
                }
            }
            if (this.shelfData && !shelfDataFound) {
                this.shelfData = null;
                this.manualShelf = true;
            }
        },
        // eslint-disable-next-line no-unused-vars
        onShelfDataUpdate(id, comment) {
            // noop
        },
        shelfFilter (val, update) {
            if (val === '') {
                update(() => {
                    this.shelfOptions = [{ value: null, label: '-- Bitte wählen --' }];
                    for (const { id, comment } of this.uploadShelfDataConfig) {
                        this.shelfOptions.push({
                            value: `${id}-${comment}`,
                            label: `${id} - ${comment}`,
                        });
                    }
                });

                return;
            }
            update(() => {
                const needle = val.toLowerCase();
                this.shelfOptions = [];
                for (const { id, comment } of this.uploadShelfDataConfig) {
                    if (String(id).toLowerCase().indexOf(needle) > -1 || comment.toLowerCase().indexOf(needle) > -1) {
                        this.shelfOptions.push({
                            value: `${id}-${comment}`,
                            label: `${id} - ${comment}`,
                        });
                    }
                }
            });
        },
        updateShelfData() {
            if (this.shelfData) {
                const matches = /^(?<id>\d+)-(?<comment>.+)$/.exec(this.shelfData);
                this.onShelfDataUpdate(Number.parseInt(matches.groups.id), matches.groups.comment);
            } else {
                this.onShelfDataUpdate(null, null);
            }
        },
        toggleManualShelf() {
            this.shelfData = null;
            if (!this.manualShelf) {
                this.onShelfDataUpdate(null, null);
            }
        },
    },
};
